(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  function getCartCookie() {
    return decodeURIComponent(
      document.cookie
        .split('; ')
        .find((row) => row.startsWith('cart='))
        ?.split('=')[1] ?? '',
    );
  }

  function appendCartParam(link) {
    const cartCookie = getCartCookie();
    if (!cartCookie) return;
    const url = new URL(link.href);
    url.searchParams.set('cart', cartCookie);
    link.href = url.toString();
  }

  document.querySelectorAll('[data-market-link]').forEach((link) => {
    link.addEventListener('pointerenter', () => appendCartParam(link), { once: false });
    link.addEventListener('click', () => appendCartParam(link));
  });

  document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const cartId = urlParams?.get('cart');

    if (cartId) {
      const marketLinks = document.querySelectorAll('[data-market-link]');

      marketLinks.forEach((link) => {
        const url = new URL(link.href);
        // This adds/updates the 'cart' param while keeping the link's path intact
        url.searchParams.set('cart', cartId);
        link.href = url.toString();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-blog-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.tagSwiper', {
      slidesPerView: 'auto',
      spaceBetween: 24,
      centerInsufficientSlides: true,
      breakpoints: {
        768: { spaceBetween: 62 },
      },
      on: {
        init: function () {
          const activeSlide = this.el.querySelector('[data-active="true"]');
          if (activeSlide) {
            const index = Array.from(this.slides).indexOf(activeSlide);
            if (index > -1) this.slideTo(index, 0); // instantly move to that slide
          }

          this.el.style.opacity = '1';
          this.el.style.visibility = 'visible';
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
